// extracted by mini-css-extract-plugin
export default {"item":"src-components-Antd-Form-css-module__item--Jax2Y"};